import { useEffect, useState } from "react";
import { trickleListObjects } from "../../utils/api";
import BookCard from "./BookCard";

function BookList({ isAdmin, onUpload }) {
    const [books, setBooks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    try {

        useEffect(() => {
            const fetchBooks = async () => {
                try {
                    const objectType = isAdmin ? 'book:admin' : 'book:public';
                    const result = await trickleListObjects(objectType, 100, true);
                    setBooks(result.items.map(item => ({
                        id: item.objectId,
                        ...item.objectData
                    })));
                } catch (err) {
                    setError('載入書籍失敗');
                    console.error('載入書籍錯誤:', err);
                } finally {
                    setLoading(false);
                }
            };

            fetchBooks();
        }, [isAdmin]);

        if (loading) {
            return (
                <div className="flex justify-center items-center h-64" data-name="loading">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
                </div>
            );
        }

        if (error) {
            return (
                <div className="text-center text-red-600 py-8" data-name="error-message">
                    {error}
                </div>
            );
        }

        if (books.length === 0) {
            return (
                <div className="text-center py-16" data-name="empty-state">
                    <div className="text-6xl mb-4">📚</div>
                    <h3 className="text-2xl font-bold mb-2">尚無書籍</h3>
                    {isAdmin ? (
                        <>
                            <p className="text-gray-600 mb-4">上傳第一本書籍開始使用！</p>
                            <button 
                                onClick={onUpload}
                                className="btn btn-primary"
                                data-name="upload-button"
                            >
                                <i className="fas fa-upload mr-2"></i>
                                上傳 PDF
                            </button>
                        </>
                    ) : (
                        <p className="text-gray-600 mb-4">目前還沒有可用的書籍，請稍後再回來查看。</p>
                    )}
                </div>
            );
        }

        return (
            <div className="books-grid" data-name="book-list">
                {books.map(book => (
                    <BookCard key={book.id} book={book} />
                ))}
            </div>
        );
    } catch (error) {
        console.error('書籍列表錯誤:', error);
        reportError(error);
        return null;
    }
}

export default BookList;